import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',

  '& .header': {
    marginBottom: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& .MuiTypography-root': {
      fontWeight: '500',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: theme.palette.text.primary,
    },

    '& .chip-container': {
      display: 'flex',
      alignItems: 'center',
    },

    '& .icons': {
      display: 'flex',
      alignItems: 'center',

      '& button': {
        width: '48px',
        height: '48px',

        '& svg': {
          width: '17.45px',
          height: '17.45px',
          // border: '1px solid red',
        },
      },

      '& .action': {
        '& .MuiIconButton-colorPrimary': {
          backgroundColor: theme.legacyColors.PRIMARY_80,

          ':not(:last-child)': {
            marginRight: '8px',
          },
        },

        '& .active-icon-btn': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
      },

      '& .MuiIconButton-colorError': {
        color: theme.palette.error.main,
        backgroundColor: theme.palette.error.light, //theme.ERROR_OUTLINED
        marginRight: '20px',
      },
    },
  },

  '& .recorder': {
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.shape.customBorderRadius.main,
    backgroundColor: theme.palette.background.default,

    '& .ellipse': {
      width: '12px',
      height: '12px',
      borderRadius: theme.shape.customBorderRadius.large,
      backgroundColor: theme.palette.error.main,
      marginRight: '8px',
    },

    '& .MuiTypography-root': {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: theme.palette.text.primary,
    },
  },
}))
